import styles from './style.postcss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import is from 'is_js';

import { testClass } from 'omni-common-ui';

const INTEGER_PATTERN = /^\d+$/;

export default class MarkInput extends Component {
  constructor(props) {
    super(props);
    this._onChange = this._onChange.bind(this);
  }

  _onChange(event) {
    const { value } = event.target;
    const { maxMark, onChange } = this.props;
    if (value === '') {
      onChange(value);
      return;
    }
    if (! INTEGER_PATTERN.test(value)) return;
    if (is.number(maxMark) && Number.parseInt(value, 10) > maxMark) return;
    onChange(value);
  }

  render() {
    const { value } = this.props;
    return <input type="text"
        className={classnames(styles.KetExamMarkView_markInput, testClass('ket-mark-input'))}
        value={value}
        onChange={this._onChange} />;
  }
}

MarkInput.propTypes = {
  value: PropTypes.string.isRequired,
  maxMark: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./containers/Group/KetExam/MarkView/MarkInput.jsx